/** Customer-facing proposal locales — keep aligned with org/project language options in the main app. */
export const LOCALES_SUPPORTED_CUSTOMER_FACING: Record<string, string> = {
  en: 'English',
  en_US: 'English (US)',
  nl: 'Dutch',
  sv: 'Swedish',
  es: 'Spanish',
  es_MX: 'Spanish (Mexico)',
  fr: 'French',
  de: 'German',
  pl: 'Polish',
  pt: 'Portuguese',
  it: 'Italian',
  da: 'Danish',
  fi: 'Finnish',
  no: 'Norwegian',
  th: 'Thai',
}

export type LanguageChoice = { id: string | null; name: string }

export const getLanguageChoices = (): LanguageChoice[] => [
  { id: null, name: 'Default' },
  ...Object.entries(LOCALES_SUPPORTED_CUSTOMER_FACING).map(([key, value]) => ({ id: key, name: value })),
]
